import { render, staticRenderFns } from "./Luckywheel.vue?vue&type=template&id=65cbbd86&scoped=true"
import script from "./Luckywheel.vue?vue&type=script&lang=js"
export * from "./Luckywheel.vue?vue&type=script&lang=js"
import style0 from "./Luckywheel.vue?vue&type=style&index=0&id=65cbbd86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cbbd86",
  null
  
)

export default component.exports